import React, { useRef } from 'react'
import template from '../templat.jpeg'
import mp3 from '../audio.mpeg'

const Audio = () => {
  const audioRef = useRef(null)

  const handlePlay = () => {
    if (audioRef.current) {
      audioRef.current.play()
    }
  }

  const handlePause = () => {
    if (audioRef.current) {
      audioRef.current.pause()
    }
  }

  return (
    <div style={{ 
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '100vh',
      backgroundColor: '#f5f5f5'
    }}>
      <div 
        style={{ 
          cursor: 'pointer',
          width: '300px',
          height: '300px',
          backgroundImage: `url(${template})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          borderRadius: '10px',
          boxShadow: '0 4px 8px rgba(0,0,0,0.2)',
          transition: 'transform 0.3s ease, box-shadow 0.3s ease'
        }}
        onClick={handlePlay}
        onMouseEnter={(e) => {
          e.target.style.transform = 'scale(1.03)'
          e.target.style.boxShadow = '0 6px 12px rgba(0,0,0,0.3)'
        }}
        onMouseLeave={(e) => {
          e.target.style.transform = 'scale(1)'
          e.target.style.boxShadow = '0 4px 8px rgba(0,0,0,0.2)'
        }}
      >
        <div style={{
          backgroundColor: 'rgba(0,0,0,0.6)',
          color: 'white',
          padding: '15px 30px',
          borderRadius: '50px',
          fontSize: '18px',
          fontWeight: 'bold',
          transition: 'background-color 0.3s ease'
        }}
        onMouseEnter={(e) => {
          e.target.style.backgroundColor = 'rgba(0,0,0,0.8)'
        }}
        onMouseLeave={(e) => {
          e.target.style.backgroundColor = 'rgba(0,0,0,0.6)'
        }}>
          ▶ Play Audio
        </div>
      </div>
      <audio ref={audioRef} src={mp3} />
      
      <div style={{ 
        marginTop: '30px', 
        display: 'flex', 
        gap: '20px',
        justifyContent: 'center',
        alignItems: 'center'
      }}>
        <button 
          onClick={handlePlay}
          style={{
            padding: '14px 40px',
            fontSize: '18px',
            fontWeight: 'bold',
            color: '#fff',
            backgroundColor: '#4CAF50',
            border: 'none',
            borderRadius: '50px',
            cursor: 'pointer',
            transition: 'all 0.3s ease',
            boxShadow: '0 4px 6px rgba(76, 175, 80, 0.4)',
            display: 'flex',
            alignItems: 'center',
            gap: '10px',
            minWidth: '120px',
            justifyContent: 'center'
          }}
          onMouseEnter={(e) => {
            e.target.style.backgroundColor = '#45a049'
            e.target.style.transform = 'translateY(-2px)'
            e.target.style.boxShadow = '0 6px 8px rgba(76, 175, 80, 0.5)'
          }}
          onMouseLeave={(e) => {
            e.target.style.backgroundColor = '#4CAF50'
            e.target.style.transform = 'translateY(0)'
            e.target.style.boxShadow = '0 4px 6px rgba(76, 175, 80, 0.4)'
          }}
          onMouseDown={(e) => {
            e.target.style.transform = 'scale(0.95)'
          }}
          onMouseUp={(e) => {
            e.target.style.transform = 'scale(1)'
          }}
        >
          <span style={{ fontSize: '20px' }}>▶</span> Play
        </button>
        
        <button 
          onClick={handlePause}
          style={{
            padding: '14px 40px',
            fontSize: '18px',
            fontWeight: 'bold',
            color: '#fff',
            backgroundColor: '#f44336',
            border: 'none',
            borderRadius: '50px',
            cursor: 'pointer',
            transition: 'all 0.3s ease',
            boxShadow: '0 4px 6px rgba(244, 67, 54, 0.4)',
            display: 'flex',
            alignItems: 'center',
            gap: '10px',
            minWidth: '120px',
            justifyContent: 'center'
          }}
          onMouseEnter={(e) => {
            e.target.style.backgroundColor = '#da190b'
            e.target.style.transform = 'translateY(-2px)'
            e.target.style.boxShadow = '0 6px 8px rgba(244, 67, 54, 0.5)'
          }}
          onMouseLeave={(e) => {
            e.target.style.backgroundColor = '#f44336'
            e.target.style.transform = 'translateY(0)'
            e.target.style.boxShadow = '0 4px 6px rgba(244, 67, 54, 0.4)'
          }}
          onMouseDown={(e) => {
            e.target.style.transform = 'scale(0.95)'
          }}
          onMouseUp={(e) => {
            e.target.style.transform = 'scale(1)'
          }}
        >
          <span style={{ fontSize: '20px' }}>⏸</span> Pause
        </button>
      </div>
    </div>
  )
}

export default Audio